// Référentiels du suivi commercial XoraLearn (statuts, sources, actions types)

export const STATUTS = [
    { value: 'a_contacter', label: 'À contacter', emoji: '⚪', interet: 0, badge: 'bg-slate-50 text-slate-600 border-slate-200', dot: 'bg-slate-300' },
    { value: 'contacte', label: 'Contacté', emoji: '🔵', interet: 10, badge: 'bg-sky-50 text-sky-700 border-sky-200', dot: 'bg-sky-500' },
    { value: 'reponse_recue', label: 'Réponse reçue', emoji: '🟡', interet: 30, badge: 'bg-yellow-50 text-yellow-700 border-yellow-200', dot: 'bg-yellow-400' },
    { value: 'interesse', label: 'Intéressé', emoji: '🟠', interet: 50, badge: 'bg-orange-50 text-orange-700 border-orange-200', dot: 'bg-orange-500' },
    { value: 'demo_proposee', label: 'Démo proposée', emoji: '🟣', interet: 60, badge: 'bg-purple-50 text-purple-700 border-purple-200', dot: 'bg-purple-500' },
    { value: 'demo_programmee', label: 'Démo programmée', emoji: '🔵', interet: 70, badge: 'bg-indigo-50 text-indigo-700 border-indigo-200', dot: 'bg-indigo-500' },
    { value: 'demo_effectuee', label: 'Démo effectuée', emoji: '🟢', interet: 75, badge: 'bg-teal-50 text-teal-700 border-teal-200', dot: 'bg-teal-500' },
    { value: 'offre_envoyee', label: 'Offre envoyée', emoji: '🟢', interet: 80, badge: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
    { value: 'negociation', label: 'En négociation', emoji: '🟢', interet: 90, badge: 'bg-green-50 text-green-700 border-green-200', dot: 'bg-green-600' },
    { value: 'gagne', label: 'Client gagné', emoji: '✅', interet: 100, badge: 'bg-green-600 text-white border-green-600', dot: 'bg-green-700' },
    { value: 'pas_interesse', label: 'Pas intéressé', emoji: '🔴', interet: 0, badge: 'bg-red-50 text-red-700 border-red-200', dot: 'bg-red-500' },
    { value: 'pas_de_reponse', label: 'Pas de réponse', emoji: '📞', interet: 0, badge: 'bg-slate-100 text-slate-700 border-slate-300', dot: 'bg-slate-400' }
];

export const STATUT_MAP = Object.fromEntries(STATUTS.map(s => [s.value, s]));

// Statuts "fermés" : plus besoin de relance
export const STATUTS_CLOS = ['gagne', 'pas_interesse'];

export const SOURCES = [
    { value: 'facebook', label: 'Facebook' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'telephone', label: 'Téléphone' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'email', label: 'Email' },
    { value: 'visite', label: 'Visite' },
    { value: 'recommandation', label: 'Recommandation' },
    { value: 'recherche', label: 'Recherche' },
    { value: 'autre', label: 'Autre' }
];

export const SOURCE_MAP = Object.fromEntries(SOURCES.map(s => [s.value, s]));

export const TYPES_ETABLISSEMENT = [
    'École privée',
    "Centre d'étude",
    'Centre de formation',
    'Jardin d\'enfants',
    'Lycée / Collège privé',
    'Université privée',
    'Individuel'
];

export const ACTIONS_SUGGESTIONS = [
    'Email envoyé',
    'Appel effectué',
    'WhatsApp envoyé',
    'Message Facebook envoyé',
    'Message Instagram envoyé',
    'Visite effectuée',
    'Présentation envoyée',
    'Démo faite',
    'Offre envoyée',
    'Relance effectuée',
    'Contrat signé'
];

export const RESULTATS_ACTION = [
    { value: 'positif', label: 'Échange positif', emoji: '💬', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    { value: 'pas_de_reponse', label: 'Ne répond pas', emoji: '📞', color: 'bg-slate-100 text-slate-700 border-slate-200' },
    { value: 'occupe', label: 'Occupé / Rappeler', emoji: '⏳', color: 'bg-amber-50 text-amber-700 border-amber-200' },
    { value: 'rdv_fixe', label: 'RDV / Démo fixé', emoji: '📅', color: 'bg-blue-50 text-blue-700 border-blue-200' },
    { value: 'devis_demande', label: 'Devis demandé', emoji: '📄', color: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
    { value: 'refus', label: 'Pas intéressé / Refus', emoji: '❌', color: 'bg-red-50 text-red-700 border-red-200' }
];

export const RESULTAT_MAP = Object.fromEntries(RESULTATS_ACTION.map(r => [r.value, r]));

export const OBJECTIONS = [
    { value: 'prix_eleve', label: 'Prix jugé élevé / Budget', emoji: '💸', badge: 'bg-red-50 text-red-700 border-red-200' },
    { value: 'deja_equipe', label: 'Déjà équipé (Concurrent)', emoji: '🏢', badge: 'bg-orange-50 text-orange-700 border-orange-200' },
    { value: 'mauvais_timing', label: 'Mauvais timing (Rentrée/Examens)', emoji: '⏳', badge: 'bg-amber-50 text-amber-700 border-amber-200' },
    { value: 'decideur_absent', label: 'Décideur absent / Réflexion', emoji: '👤', badge: 'bg-purple-50 text-purple-700 border-purple-200' },
    { value: 'prefere_papier', label: 'Pas de besoin (Papier / Excel)', emoji: '📄', badge: 'bg-slate-100 text-slate-700 border-slate-200' },
    { value: 'autre', label: 'Autre frein', emoji: '⚠️', badge: 'bg-slate-100 text-slate-600 border-slate-200' }
];

export const OBJECTION_MAP = Object.fromEntries(OBJECTIONS.map(o => [o.value, o]));

export const PROCHAINES_ACTIONS_SUGGESTIONS = [
    'Relancer par téléphone',
    'Relancer par WhatsApp',
    'Relancer par email',
    'Envoyer présentation',
    'Programmer démo',
    'Faire démo',
    'Envoyer prix',
    'Envoyer offre',
    'Attendre réponse',
    'Appeler',
    'Visiter'
];

export const interetLevel = (v = 0) => {
    if (v >= 90) return { label: 'Presque client', bar: 'bg-green-600', text: 'text-green-700' };
    if (v >= 60) return { label: 'Intéressé', bar: 'bg-emerald-500', text: 'text-emerald-700' };
    if (v >= 30) return { label: 'Moyen', bar: 'bg-amber-400', text: 'text-amber-700' };
    return { label: 'Faible', bar: 'bg-slate-300', text: 'text-slate-500' };
};

// ── Dates ──
const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

export const toInputDate = (d) => {
    if (!d) return '';
    const x = new Date(d);
    if (isNaN(x.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
};

export const formatDate = (d, withYear = false) => {
    if (!d) return '—';
    const x = new Date(d);
    if (isNaN(x.getTime())) return '—';
    return x.toLocaleDateString('fr-FR', withYear
        ? { day: '2-digit', month: '2-digit', year: 'numeric' }
        : { day: '2-digit', month: '2-digit' });
};

export const formatDateTime = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/** Number of days between today and the given date (negative = late) */
export const daysFromToday = (d) => {
    if (!d) return null;
    return Math.round((startOfDay(d) - startOfDay(new Date())) / 86400000);
};

export const isToday = (d) => {
    if (!d) return false;
    const date = new Date(d);
    if (isNaN(date.getTime())) return false;
    const now = new Date();
    return date.getDate() === now.getDate() &&
           date.getMonth() === now.getMonth() &&
           date.getFullYear() === now.getFullYear();
};

export const hadActionToday = (p) => {
    if (isToday(p.dateDerniereAction)) return true;
    if (Array.isArray(p.historique)) {
        return p.historique.some(h => isToday(h.date));
    }
    return false;
};

export const hasActionHistory = (p) => {
    if (p.derniereAction && p.derniereAction.trim() !== '') return true;
    if (Array.isArray(p.historique) && p.historique.length > 0) return true;
    return false;
};

export const isWaitingAction = (actionStr) => {
    if (!actionStr) return false;
    const a = actionStr.toLowerCase().trim();
    return a.includes('attend') || a.includes('attente') || a.includes('réflexion') || a.includes('reflexion');
};

/** 'late' | 'today' | 'soon' (<= 7 days) | 'later' | 'waiting' | 'none' */
export const echeanceState = (prospect) => {
    if (STATUTS_CLOS.includes(prospect.statut)) return 'none';
    const diff = daysFromToday(prospect.dateProchaineAction);
    if (diff === null) {
        return isWaitingAction(prospect.prochaineAction) ? 'waiting' : 'none';
    }
    if (diff < 0) return 'late';
    if (diff === 0) return 'today';
    if (diff <= 7) return 'soon';
    return 'later';
};
